import { render, staticRenderFns } from "./CourseShow.vue?vue&type=template&id=c5068876&scoped=true&"
import script from "./CourseShow.vue?vue&type=script&lang=js&"
export * from "./CourseShow.vue?vue&type=script&lang=js&"
import style0 from "./CourseShow.vue?vue&type=style&index=0&id=c5068876&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5068876",
  null
  
)

export default component.exports